<template>
  <va-dropdown
    class="settings-dropdown"
    offset="0, 16px"
  >
    <va-icon
      name="vuestic-iconset vuestic-iconset-settings"
      style="font-size: 1.4rem; display: flex;"
      class="settings-dropdown__icon"
      slot="anchor"
      :color="$themes.textColor"
    />

    <div class="settings-dropdown__content pl-4 pr-4 pt-2 pb-2">
      <div class="settings-dropdown__content-label mt-2 mb-3" :style="{color: this.$themes.primary}">
        {{$t('dashboard.navigationLayout')}}
      </div>
      <va-button-toggle
        outline
        v-model="isTopBarProxy"
        :options="options"
        class="settings-dropdown__control mb-2"
        small
      />

      <va-input type="number" min="0" v-model="rogo_fee" :label="$t('settings.rogo_fee')">
        <va-button :disabled="rogo_fee === old_rogo_fee || rogo_fee < 0 || rogo_fee===''" slot="append" @click="editSettings('rogo_fee')" style="margin-right: 0;" small>
          ✓
        </va-button>
      </va-input>
      <va-input type="email" v-model="rogo_email" :label="$t('settings.rogo_email')">
        <va-button  :disabled="rogo_email === old_rogo_email" slot="append" @click="editSettings('rogo_email')" style="margin-right: 0;" small>
          ✓
        </va-button>
      </va-input>
      <va-input type="number" min="0" v-model="lender_profit_limit" :label="$t('settings.lender_profit_limit')">
        <va-button  :disabled="lender_profit_limit === old_lender_profit_limit  || lender_profit_limit < 0 || lender_profit_limit === ''" slot="append" @click="editSettings('lender_profit_limit')" style="margin-right: 0;" small>
          ✓
        </va-button>
      </va-input>
    </div>
  </va-dropdown>
</template>

<script>
import { ColorThemeMixin } from '../../../../../services/vuestic-ui'
import { mapActions } from 'vuex'

export default {
  name: 'settings-dropdown',
  inject: ['contextConfig'],
  components: {},
  mixins: [ColorThemeMixin],
  props: {
    isTopBar: Boolean,
  },
  data () {
    return {
      rogo_fee: null,
      rogo_email: null,
      lender_profit_limit: null,
      old_rogo_fee: null,
      old_rogo_email: null,
      old_lender_profit_limit: null,
      options: [
        { label: this.$t('dashboard.sideBarButton'), value: String(false) }, // NOTE: boolean is unsupported for va-dropdown
        { label: this.$t('dashboard.topBarButton'), value: String(true) },
      ],
    }
  },
  methods: {
    ...mapActions(['Settings/fetch', 'Settings/edit']),
    async editSettings(key) {
      const body = {}
      body[key] = this[key]
      this['Settings/edit'](body)
      this[`old_${key}`] = body[key]
    },
  },
  computed: {
    isTopBarProxy: {
      get () {
        return String(this.isTopBar)
      },
      set (isTopBar) {
        const value = isTopBar === 'true' // NOTE: convert string to boolean
        this.$emit('update:isTopBar', value)
      },
    },
  },
  async created() {
    const { data } = await this['Settings/fetch']()
    this.rogo_fee = data.rogo_fee
    this.rogo_email = data.rogo_email
    this.lender_profit_limit = data.lender_profit_limit
    this.old_rogo_fee = data.rogo_fee
    this.old_rogo_email = data.rogo_email
    this.old_lender_profit_limit = data.lender_profit_limit
  },
}
</script>

<style lang="scss">

.settings-dropdown {
  cursor: pointer;

  &__icon {
    position: relative;
    display: flex;
    align-items: center;
  }

  &__content {
    background-color: var(--va-background);
    box-shadow: $gray-box-shadow;
    border-radius: 0.5rem;

    &-label {
      margin-bottom: 0.5rem;
    }
  }

  &__control {
    .va-button-group {
      margin: 0;
    }
  }

  .va-dropdown__anchor {
    display: inline-block;
  }
}
</style>
